import { V2 } from 'engine/lib/V2';
import { LaserIcon } from 'game/components/modules/icons/LaserIcon';
import { WateringCanIcon } from 'game/components/modules/icons/WateringCanIcon';
import { mixColor } from 'game/lib/colors';
import { createStyles } from 'game/lib/createStyles';
import { BotToolChoice, InventoryItem, WATERING_CAN_MAX } from 'game/state/BotState';
import { colors } from 'game/styles/theme';
import times from 'lodash/times';

const inventorySize: V2 = [3, 5];

const classes = createStyles({
  inventory: {
    border: `1px solid ${colors.screenTealLight}`,
    aspectRatio: inventorySize.join(' / '),
    position: 'relative',
    maxWidth: '100%',
    maxHeight: '100%',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
  },
  inventoryCell: {
    width: `${(100 / inventorySize[0])}%`,
    aspectRatio: '1 / 1',
    position: 'relative',
    padding: 4,
    '&:before': {
      content: ' ',
      position: 'absolute',
      top: -1,
      right: -1,
      bottom: -1,
      left: -1,
      borderRight: `1px solid ${colors.screenTealLight}`,
      borderBottom: `1px solid ${colors.screenTealLight}`,
    },
  },
  meter: {
    position: 'absolute',
    width: '100%',
    bottom: 0,
    left: 0,
    border: `1px solid ${colors.screenTealLight}`,
    height: '20%',
  },
  meterProgress: {
    height: '100%',
    background: colors.screenTealLight,
  },
});

const renderItem = (item?: InventoryItem): JSX.Element | null => {
  if (!item) return null;
  switch (item.type) {
    case BotToolChoice.WateringCan: return (
      <>
        <svg viewBox="0 0 121 93" width="100%">
          <g transform="translate(60.5 46.5)">
            <WateringCanIcon stroke={colors.screenTealLight} strokeWidth={4} />
          </g>
        </svg>
        <div className={classes.meter}>
          <div
            style={{
              width: `${(item.count / WATERING_CAN_MAX) * 100}%`,
              background: mixColor(
                colors.screenError,
                colors.screenTealLight,
                item.count / WATERING_CAN_MAX,
              ),
            }}
            className={classes.meterProgress}
          />
        </div>
      </>
    );
    case BotToolChoice.Laser: return (
      <>
        <svg viewBox="0 0 121 93" width="100%">
          <g transform="translate(60.5 46.5)">
            <LaserIcon stroke={colors.screenTealLight} strokeWidth={4} />
          </g>
        </svg>
        <div className={classes.meter}>
          <div
            style={{
              width: `${item.count * 100}%`,
              background: mixColor(
                colors.screenError,
                colors.screenTealLight,
                item.count,
              ),
            }}
            className={classes.meterProgress}
          />
        </div>
      </>
    );
    case BotToolChoice.Axe: return null;
  }
};

export const InventoryGrid: React.FC<{ items: InventoryItem[] }> = ({ items }) => (
  <div className={classes.inventory}>
    {times(inventorySize[0] * inventorySize[1], i => (
      <div key={i} className={classes.inventoryCell}>
        {renderItem(items[i])}
      </div>
    ))}
  </div>
);
